export const LOGO_URL = "https://customer-assets-wrfwihn1.emergentagent.net/job_ekaa-kitchener/artifacts/sff9c6cg_Logo.jpg";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1766832255363-c9f060ade8b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBmaW5lJTIwZGluaW5nJTIwcmVzdGF1cmFudCUyMGludGVyaW9yJTIwZGFya3xlbnwwfHx8fDE3ODUyNjc0MjF8MA&ixlib=rb-4.1.0&q=85",
  dishDark: "https://images.unsplash.com/photo-1692197275441-40c874f40385?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxnb3VybWV0JTIwaW5kaWFuJTIwZGlzaCUyMGRhcmslMjBtb29keSUyMHBsYXRpbmd8ZW58MHx8fHwxNzgzODU4MTM2fDA&ixlib=rb-4.1.0&q=85",
  biryani: "https://images.unsplash.com/photo-1710091691777-3115088962c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwyfHxnb3VybWV0JTIwaW5kaWFuJTIwZGlzaCUyMGRhcmslMjBtb29keSUyMHBsYXRpbmd8ZW58MHx8fHwxNzgzODU4MTM2fDA&ixlib=rb-4.1.0&q=85",
  cocktail: "https://images.unsplash.com/photo-1500217052183-bc01eee1a74e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjb2NrdGFpbCUyMGVsZWdhbnQlMjBiYXIlMjBkYXJrfGVufDB8fHx8MTc4NTI2NzQyMXww&ixlib=rb-4.1.0&q=85",
  bar: "https://images.unsplash.com/photo-1623408859815-22534357b3db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjb2NrdGFpbCUyMGVsZWdhbnQlMjBiYXIlMjBkYXJrfGVufDB8fHx8MTc4NTI2NzQyMXww&ixlib=rb-4.1.0&q=85",
  tandoori: "https://images.unsplash.com/photo-1633945274405-b6c8069047b0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  curry: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  dessert: "https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  spices: "https://images.unsplash.com/photo-1596797038530-2c107229654b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  interior: "https://images.unsplash.com/photo-1550966871-3ed3cdb5ed0c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  family: "https://images.unsplash.com/photo-1592861956120-e524fc739696?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const MENU = [
  { category: "Street Food & Chaat", items: [
    { name: "Aloo Tikki Chaat", price: 12 },
    { name: "Chana Samosa Chaat", price: 12 },
    { name: "Golgappe Shots", price: 12 },
    { name: "Dahi Bhalla Chaat", price: 12 },
    { name: "Dahi Puri", price: 12 },
    { name: "Burger", price: 10 },
  ]},
  { category: "Soups", items: [
    { name: "Sweet Corn Soup", price: 12 },
    { name: "Veg Soup", price: 12 },
    { name: "Manchow Soup", price: 12 },
    { name: "Chicken Soup", price: 12 },
    { name: "Chicken Manchow Soup", price: 12 },
  ]},
  { category: "Momos", items: [
    { name: "Steamed Momos (Veg / Non-Veg)", price: 15 },
    { name: "Fried Momos", price: 15 },
    { name: "Tandoori Momos", price: 18 },
    { name: "Chilli Momos", price: 18 },
  ]},
  { category: "Appetizers", items: [
    { name: "Masala Papad", price: 7 },
    { name: "French Fries", price: 5 },
    { name: "Mix Veg Pakora", price: 12 },
    { name: "Paneer Pakora", price: 12 },
    { name: "Chicken Pakora", price: 15 },
    { name: "Fish Pakora", price: 15 },
    { name: "Dahi Kebab", price: 14 },
    { name: "Hara Bhara Kebab", price: 14 },
    { name: "Spring Roll", price: 14 },
    { name: "Mushroom Duplex", price: 16 },
    { name: "Honey Chilli Potato", price: 18 },
    { name: "Veg Manchurian", price: 15 },
    { name: "Chilli Paneer", price: 18 },
    { name: "Chilli Chicken", price: 18 },
    { name: "Veg/Chicken Noodles", price: 15 },
  ]},
  { category: "Tandoori Veg", items: [
    { name: "Tandoori Red Champ", price: 18 },
    { name: "Malai Champ", price: 18 },
    { name: "Paneer Tikka", price: 18 },
    { name: "Malai Paneer Tikka", price: 18 },
    { name: "Achari Paneer Tikka", price: 18 },
  ]},
  { category: "Tandoori Non-Veg", items: [
    { name: "Ekaa Special Angara Tikka", price: 20 },
    { name: "Ekaa Special Chapli Kabab", price: 20 },
    { name: "Tandoori Chicken Half", price: 16 },
    { name: "Tandoori Chicken Full", price: 24 },
    { name: "Chicken Tikka", price: 20 },
    { name: "Achari Chicken Tikka", price: 20 },
    { name: "Chicken Mint Tikka", price: 20 },
    { name: "Mughlai Chicken Tikka", price: 20 },
    { name: "Chicken Seekh Kabab", price: 20 },
    { name: "Tandoori Salmon", price: 24 },
    { name: "Tandoori Shrimp", price: 20 },
    { name: "Fish Tikka", price: 20 },
    { name: "Lamb Chops", price: 24 },
  ]},
  { category: "Vegetarian Main Course", items: [
    { name: "Dal Makhni", price: 20 },
    { name: "Yellow Dal Tadka", price: 20 },
    { name: "Paneer Lababdar", price: 20 },
    { name: "Paneer Tikka Masala", price: 20 },
    { name: "Butter Paneer Masala", price: 20 },
    { name: "Shahi Paneer", price: 20 },
    { name: "Palak Paneer", price: 20 },
    { name: "Paneer Bhurji", price: 20 },
    { name: "Kadai Paneer", price: 20 },
    { name: "Methi Malai Paneer", price: 20 },
    { name: "Veg Manchurian Gravy", price: 20 },
    { name: "Chilli Paneer Gravy", price: 20 },
    { name: "Aloo Gobi", price: 20 },
    { name: "Bhindi Masala", price: 20 },
    { name: "Mushroom Do Pyaza", price: 20 },
    { name: "Mix Veg", price: 20 },
  ]},
  { category: "Non-Veg Curries", items: [
    { name: "Butter Chicken", price: 20 },
    { name: "Chicken Lababdar", price: 20 },
    { name: "Chicken Curry", price: 20 },
    { name: "Kadai Chicken", price: 20 },
    { name: "Madras Chicken", price: 22 },
    { name: "Rara Chicken", price: 20 },
    { name: "Adhraki Chicken", price: 20 },
    { name: "Egg Bhurji", price: 20 },
    { name: "Fish Curry", price: 20 },
  ]},
  { category: "Goat Curries", items: [
    { name: "Goat Curry", price: 20 },
    { name: "Kadai Goat", price: 20 },
    { name: "Mutton Handi", price: 28 },
    { name: "Goat Korma", price: 20 },
    { name: "Palak Goat", price: 20 },
  ]},
  { category: "Rice & Biryani", items: [
    { name: "Plain Rice", price: 6 },
    { name: "Jeera Rice", price: 8 },
    { name: "Veg Biryani", price: 14 },
    { name: "Chicken Biryani", price: 15 },
    { name: "Soya Champ Biryani", price: 15 },
    { name: "Goat Biryani", price: 16 },
    { name: "Shrimp Biryani", price: 15 },
    { name: "Veg/Chicken/Egg Fried Rice", price: 15 },
  ]},
  { category: "Breads", items: [
    { name: "Tandoori Roti", price: 3 },
    { name: "Butter Naan", price: 3 },
    { name: "Garlic Naan", price: 4 },
    { name: "Chilli Garlic Naan", price: 5 },
    { name: "Laccha Paratha", price: 5 },
    { name: "Stuffed Paratha", price: 6 },
  ]},
  { category: "Salads & Raita", items: [
    { name: "Onion Salad", price: 5 },
    { name: "Green Salad", price: 7 },
    { name: "Plain Yogurt", price: 4 },
    { name: "Veggie Raita", price: 6 },
    { name: "Boondi Raita", price: 6 },
  ]},
  { category: "Desserts", items: [
    { name: "Gulab Jamun", price: 7 },
    { name: "Ras Malai", price: 7 },
    { name: "Dessert Combo", price: 7 },
    { name: "Gajar Halwa", price: 9 },
    { name: "Moong Dal Halwa", price: 9 },
    { name: "Brownie with Ice Cream", price: 11 },
    { name: "Homemade Ice Cream", price: 10 },
  ]},
  { category: "Special Thali", items: [
    { name: "Veg Thali", price: 15 },
    { name: "Meat Thali", price: 15 },
    { name: "Chana Bhatura", price: 15 },
    { name: "Amritsari Kulcha", price: 15 },
  ]},
];

export const TESTIMONIALS = [
  { name: "Priya Sharma", role: "Food Blogger", text: "Ekaa redefines fine Indian dining in Kitchener. The Ekaa Special Angara Tikka was smoky perfection, and the ambience felt like a private celebration.", rating: 5 },
  { name: "Marcus Bennett", role: "Regular Guest", text: "From the handcrafted cocktails to the butter chicken, every detail is elevated. Easily the most elegant restaurant in the Waterloo region.", rating: 5 },
  { name: "Anita Kapoor", role: "Event Host", text: "We booked Ekaa for a family celebration and the catering team exceeded every expectation. Authentic flavors, luxurious presentation.", rating: 5 },
  { name: "David Chen", role: "Date Night", text: "The tandoori platters and the dark, golden interior make it perfect for a special evening. Service was warm and attentive throughout.", rating: 5 },
];

export const WHY_CHOOSE = [
  { title: "Authentic Indian Cuisine", desc: "Time-honored recipes crafted with soul and tradition.", icon: "UtensilsCrossed" },
  { title: "Luxury Dining Experience", desc: "An atmosphere of gold-lit elegance and quiet indulgence.", icon: "Gem" },
  { title: "Premium Cocktails", desc: "Handcrafted signature drinks to pair with every dish.", icon: "Martini" },
  { title: "Fresh Ingredients", desc: "Sourced daily for uncompromising flavor and quality.", icon: "Leaf" },
  { title: "Takeout & Delivery", desc: "Enjoy Ekaa at home via DoorDash and Uber Eats.", icon: "Bike" },
  { title: "Catering & Private Events", desc: "Bespoke menus for weddings, corporate & celebrations.", icon: "PartyPopper" },
  { title: "Friendly Service", desc: "Hospitality that treats every guest like family.", icon: "HeartHandshake" },
  { title: "Late Night Dining", desc: "Open every day until 2:00 AM for the night owls.", icon: "Moon" },
];

export const DELIVERY_LINKS = {
  doordash: "https://www.doordash.com/store/ekaa-cocktail-&-cuisine-kitchener-49953951/115031346/?rwg_token=AE37R_iRxTy6ywVTeGPIJb9ZFOujf-EtiOhWWjEA7n7hbFcMmstrPQmfgrzIQ2nDHeJtFu_xskrn6lVyuuII1cv6xeD9_TIhWQ==&utm_campaign=gpa",
  ubereats: "https://www.ubereats.com/ca/store/ekaa-cocktails-%26-cuisine/906Fi1RjTd6XkeTBaXO3Yw?diningMode=DELIVERY&sc=SEARCH_SUGGESTION",
};

export const DRINKS = [
  { category: "Signature Cocktails", items: [
    { name: "Classic Mojito", desc: "White rum, mint, lime & soda", price: 14 },
    { name: "Classic Margarita", desc: "Tequila, lime & triple sec", price: 15 },
    { name: "Spicy Margarita", desc: "Jalapeño-infused tequila & lime", price: 16 },
    { name: "Devil Margarita", desc: "Frozen margarita with red wine float", price: 17 },
    { name: "Classic Martini", desc: "Gin or vodka with dry vermouth", price: 15 },
    { name: "Lychee Martini", desc: "Vodka, lychee & citrus", price: 16 },
    { name: "Old Fashioned", desc: "Bourbon, bitters & orange", price: 16 },
    { name: "Tequila Sunrise", desc: "Tequila, orange juice & grenadine", price: 15 },
    { name: "Long Island Iced Tea", desc: "Five spirits with cola", price: 18 },
    { name: "Jungle Bird", desc: "Dark rum, Campari & pineapple", price: 16 },
    { name: "Cosmopolitan", desc: "Vodka, cranberry & lime", price: 15 },
    { name: "Melon Punch", desc: "Vodka, melon liqueur & citrus", price: 15 },
    { name: "Moscow Mule", desc: "Vodka, ginger beer & lime", price: 15 },
    { name: "Bloody Mary", desc: "Vodka, tomato juice & spices", price: 15 },
  ]},
  { category: "Mocktails", items: [
    { name: "Virgin Mojito", desc: "Mint, lime, soda & sugar", price: 8 },
    { name: "Piña Colada (Virgin)", desc: "Pineapple & coconut cream", price: 9 },
    { name: "Candy Shop", desc: "Mixed berries, citrus & candy", price: 9 },
    { name: "Shikanji", desc: "Traditional Indian lemonade", price: 7 },
    { name: "Sunrise", desc: "Orange, pineapple & grenadine", price: 8 },
    { name: "Ruby Glow", desc: "Cranberry, citrus & sparkling soda", price: 9 },
    { name: "Arnold Palmer", desc: "Iced tea & lemonade", price: 7 },
    { name: "Dragon Blush", desc: "Dragon fruit, lime & soda", price: 9 },
  ]},
  { category: "Lassi & Shakes", items: [
    { name: "Sweet Lassi", price: 6 },
    { name: "Salty Lassi", price: 6 },
    { name: "Mango Lassi", price: 7 },
    { name: "KitKat Shake", price: 8 },
    { name: "Strawberry Shake", price: 8 },
    { name: "Mango Shake", price: 8 },
    { name: "Oreo Shake", price: 8 },
  ]},
  { category: "Beers", items: [
    { name: "Molson Canadian", price: 8 },
    { name: "Budweiser", price: 8 },
    { name: "Heineken", price: 9 },
    { name: "Corona Extra", price: 9 },
    { name: "Stella Artois", price: 9 },
  ]},
  { category: "Whisky", items: [
    { name: "Crown Royal", price: 9 },
    { name: "J.P. Wiser's", price: 9 },
    { name: "Jameson", price: 10 },
    { name: "Johnnie Walker Red Label", price: 10 },
    { name: "Johnnie Walker Black Label", price: 13 },
    { name: "Johnnie Walker Gold Label", price: 18 },
    { name: "Johnnie Walker Green Label", price: 19 },
    { name: "Johnnie Walker Blue Label", price: 38 },
    { name: "Ballantine's", price: 10 },
    { name: "Chivas Regal", price: 12 },
    { name: "Glenfiddich 12", price: 15 },
    { name: "Glenfiddich 15", price: 19 },
    { name: "Glenlivet 12", price: 15 },
    { name: "Glenlivet 15", price: 19 },
    { name: "The Macallan", price: "MP" },
  ]},
  { category: "Vodka & Gin", items: [
    { name: "Smirnoff", price: 9 },
    { name: "Absolut", price: 10 },
    { name: "Grey Goose", price: 14 },
    { name: "Cîroc", price: 15 },
    { name: "Beefeater Gin", price: 10 },
    { name: "Bombay Sapphire", price: 10 },
    { name: "Hendrick's", price: 13 },
  ]},
  { category: "Tequila", items: [
    { name: "Jose Cuervo Silver", price: 10 },
    { name: "Jose Cuervo Gold", price: 10 },
    { name: "Don Julio Blanco", price: 15 },
    { name: "Don Julio Reposado", price: 16 },
    { name: "Patrón Silver", price: 16 },
    { name: "Patrón 1942", price: 40 },
    { name: "Casamigos Blanco", price: 16 },
    { name: "Casamigos Reposado", price: 17 },
    { name: "Clase Azul Reposado", price: 45 },
  ]},
  { category: "Rum, Brandy & Cognac", items: [
    { name: "Bacardi", price: 9 },
    { name: "Captain Morgan", price: 9 },
    { name: "St-Rémy Brandy", price: 10 },
    { name: "Hennessy VS", price: 15 },
  ]},
  { category: "Wine & Champagne", items: [
    { name: "Red Wine (Glass)", price: 10 },
    { name: "White Wine (Glass)", price: 10 },
    { name: "Red Wine (Bottle)", desc: "Starting at", price: 38 },
    { name: "White Wine (Bottle)", desc: "Starting at", price: 38 },
    { name: "Ace of Spades", desc: "Ekaa's special champagne", price: 950 },
  ]},
];
